import { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import ManagePreferenceHOC from '../../Material/ManagePreferenceHOC'
import withApolloClient from '../../withApolloClient'
import RestrictedSection from "../../Components/RestrictedSection"

import TPAList from './TPAList'
import TPAActions from './TPAActions'
import TPAListHeader from './TPAListHeader'


const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "date_modified", name: "Date Modified", sortable: true, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "name", name: "Name", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "feeType", name: "Fee Type", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "feeAmount", name: "Fee Amount", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "contactName", name: "Contact Name", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "contactEmail", name: "Contact Email", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "contactPhone", name: "Contact Phone", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
    { id: "description", name: "Description", sortable: false, visible: true, showInPicker: true, positionIsFixed: false },
]

class IncidentListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-date_added"],
            filterValues: {},
            refetchTPAList: false,
        }
    }

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };


    render() {
        return (
            <RestrictedSection requiredPermission="view_tpa">
                <Container fluid className="bos-listing-container">
                    <Row>
                        <Col xs={8}>
                            <TPAListHeader
                                filterValues={this.state.filterValues}
                                setFilterValues={(filterValues) => this.setState({ filterValues })}
                                defaultFilters={this.state.filterValues}
                                {...this.props}
                            />
                        </Col>
                        <Col xs={4}>
                            <TPAActions
                                columnConfig={this.props.columnConfig}
                                currentUser={this.props.currentUser}
                                refetchPreferences={this.props.refetchPreferences}
                                refetchQuery={() => this.setState({ refetchTPAList: !this.state.refetchTPAList })}
                                {...this.props}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12">
                            <TPAList
                                columnConfig={this.props.columnConfig}
                                key={String(this.state.refetchTPAList)}
                                currentUser={this.props.currentUser}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                orderBy={this.state.orderBy}
                                updateOrder={this.updateOrder}
                            />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}



export default withApolloClient(
    ManagePreferenceHOC("tpa", tableHeaders)
        (IncidentListContainer)
)
